// Centrale bedrijfsgegevens — één plek om KVK e.d. aan te vullen.
export const COMPANY = {
  name: "UPPIT",
  owner: "Tim Roosendaal",
  email: "info@uppit.nl",
  phoneDisplay: "+31 6 41 26 22 67",
  location: "Helmond, Nederland",
  kvk: "96896965",
  site: "https://uppit.nl",
};
